import { Component, OnInit } from '@angular/core';
import { LgpdService, RemovalRequestAdminDto } from './lgpd.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-lgpd-list',
  templateUrl: './lgpd-list.component.html',
  styleUrls: ['./lgpd-list.component.css']
})
export class LgpdListComponent implements OnInit {
  loading = false;
  page = 1;
  pageSize = 20;
  total = 0;

  status = '';
  items: RemovalRequestAdminDto[] = [];

  // Per-item action modal
  showActionModal = false;
  actionType: 'approve' | 'reject' = 'approve';
  selectedItem: RemovalRequestAdminDto | null = null;
  actionNotes = '';
  actioning = false;

  statusOptions = [
    { value: '', label: 'Todas' },
    { value: 'Pending', label: 'Pendentes' },
    { value: 'Approved', label: 'Aprovadas' },
    { value: 'Rejected', label: 'Rejeitadas' },
  ];

  constructor(private svc: LgpdService, private notify: NotificationService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.svc.list(this.status || undefined, this.page, this.pageSize).subscribe({
      next: (res: any) => {
        this.items = res.data || [];
        this.total = res.meta?.total || this.items.length;
        this.loading = false;
      },
      error: (err) => {
        console.error('[LGPD] erro ao carregar solicitações', err);
        this.notify.showError('Erro ao carregar solicitações');
        this.loading = false;
      }
    });
  }

  openApprove(item: RemovalRequestAdminDto): void {
    this.selectedItem = item;
    this.actionType = 'approve';
    this.actionNotes = '';
    this.showActionModal = true;
  }

  openReject(item: RemovalRequestAdminDto): void {
    this.selectedItem = item;
    this.actionType = 'reject';
    this.actionNotes = '';
    this.showActionModal = true;
  }

  closeActionModal(): void {
    this.showActionModal = false;
    this.selectedItem = null;
    this.actionNotes = '';
  }

  confirmAction(): void {
    if (!this.selectedItem || this.actioning) return;
    this.actioning = true;

    const obs = this.actionType === 'approve'
      ? this.svc.approve(this.selectedItem.id, this.actionNotes || undefined)
      : this.svc.reject(this.selectedItem.id, this.actionNotes || undefined);

    obs.subscribe({
      next: () => {
        this.actioning = false;
        this.notify.showSuccess(this.actionType === 'approve' ? 'Solicitação aprovada' : 'Solicitação rejeitada');
        this.closeActionModal();
        this.load();
      },
      error: (err) => {
        this.actioning = false;
        console.error('[LGPD] erro ao executar ação', err);
        this.notify.showError(`Erro ao ${this.actionType === 'approve' ? 'aprovar' : 'rejeitar'}`);
      }
    });
  }

  // Keep legacy methods for backward compatibility
  approve(item: RemovalRequestAdminDto): void {
    this.openApprove(item);
  }

  reject(item: RemovalRequestAdminDto): void {
    this.openReject(item);
  }

  onPageChange(p: number) {
    this.page = p;
    this.load();
  }

  displayEnd(): number {
    const end = this.page * this.pageSize;
    return end > this.total ? this.total : end;
  }

  getStatusClass(status: string): string {
    if (status === 'Pending' || status === 'pending') return 'bg-yellow-100 text-yellow-800';
    if (status === 'Approved' || status === 'approved') return 'bg-green-100 text-green-800';
    if (status === 'Rejected' || status === 'rejected') return 'bg-red-100 text-red-800';
    return 'bg-gray-100 text-gray-800';
  }
}
